export const INFLUENCER_WEB_API_HOST = process.env.NEXT_PUBLIC_INFLUENCER_WEB_API_HOST || "";

export const ONEVIEW_API_HOST = process.env.NEXT_PUBLIC_ONEVIEW_HOST || "";

export const API_ENDPOINTS = {
    GET_LOCALE_ASSETS: (locale: string) => `/assets/locale/${locale}.json`,
    GET_CITIES: "/api/v1/influencer/user/city",
    LIST_REFERRALS: "/api/v1/influencer/referral/listReferrals",
    GET_REFERRAL_DETAILS: (referralId: string) => `/api/v1/influencer/referral/${encodeURIComponent(referralId)}/details`,
    GET_HOME_BANNERS: "/api/v1/influencer/referral/home",
    GET_USER_DATA: "/api/v1/influencer/user",
    CREATE_REFERRAL: "/api/v1/influencer/referral/refer",
    GET_CITY_BONUS: "/api/v1/influencer/referral/city/bonus",
    SEND_OTP: "/v2/accounts/sendVerificationCode",
    SIGN_IN: "/v1/accounts/signInWithOTP",
    REFRESH_TOKEN: "/v1/token/refresh",
    SIGN_OUT: "/v1/accounts/signOut",
    SAVE_USER_DATA: "/api/v1/influencer/user",
    GET_EARNINGS: "/api/v1/influencer/referral/earnings",
    GET_BANKS: "/api/v2/sno/banks",
};

export const LOG_TABLES = {
    LOG: "api_log",
    ERROR: "api_error",
};

export const DP_SERVICE_URL = process.env.NEXT_PUBLIC_DP_SERVICE_HOST || "https://dp-uat.swiggyops.de";

export const STATIC_ASSETS_HOST = process.env.NEXT_PUBLIC_STATIC_ASSETS_HOST || "";
